import { Col } from 'antd';
import styled from 'styled-components';
import { ZoomInOutlined, EditOutlined, DownloadOutlined, DeleteOutlined } from '@ant-design/icons';

export const ActionsInline = styled(Col)`
	display: none;
	@media (min-width: 768px) {
		display: flex;
		justify-content: center;
	}
`;

export const ActionsMenu = styled(Col)`
	display: flex;
	@media (min-width: 768px) {
		display: none;
	}
`;

export const StyledZoomInIcon = styled(ZoomInOutlined)`
	font-size: 18px !important;
`;

export const StyledEditIcon = styled(EditOutlined)`
	font-size: 18px !important;
`;

export const StyledDownloadIcon = styled(DownloadOutlined)`
	font-size: 18px !important;
`;

export const StyledDeleteIcon = styled(DeleteOutlined)`
	font-size: 18px !important;
	color: #e74150;
`;
